module.exports = __webpack_public_path__ + "media/images/nav/icon_2-b85eb8fe533e18278c4b82cac4f1279a.svg";